import { render, staticRenderFns } from "./editCustomerCar.vue?vue&type=template&id=057c8146&scoped=true"
import script from "./editCustomerCar.vue?vue&type=script&lang=js"
export * from "./editCustomerCar.vue?vue&type=script&lang=js"
import style0 from "./editCustomerCar.vue?vue&type=style&index=0&id=057c8146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057c8146",
  null
  
)

export default component.exports